import { type ComponentType, type ReactNode, useCallback, useMemo, useState } from "react";
import { BreadcrumbTrailContext, type TrailEntry } from "./BreadcrumbTrailContext.ts";

export const BreadcrumbTrailProvider = ({ children }: { readonly children: ReactNode }) => {
  const [trail, setTrail] = useState<readonly TrailEntry[]>([]);

  const resetTrail = useCallback((path: string, search: string, hash: string, label: string, icon?: ComponentType) => {
    setTrail([{ path, search, hash, label, icon }]);
  }, []);

  const updateEntry = useCallback((path: string, search: string, hash: string, label: string, icon?: ComponentType) => {
    setTrail((prev) => {
      const index = prev.findIndex((e) => e.path === path);
      if (index >= 0) {
        return [...prev.slice(0, index), { path, search, hash, label, icon }];
      }
      // Not found — append
      return [...prev, { path, search, hash, label, icon }];
    });
  }, []);

  const value = useMemo(() => ({ trail, resetTrail, updateEntry }), [trail, resetTrail, updateEntry]);

  return <BreadcrumbTrailContext value={value}>{children}</BreadcrumbTrailContext>;
};
